"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var Button = __importStar(require("./A_Button"));
var Component = function (p) {
    var _a = Hooks.useState(''), newArticleType = _a[0], setNewArticleType = _a[1];
    var hasSpaces = newArticleType.includes(' ');
    var onCancelClick = function () {
        p.onCancel();
        setNewArticleType('');
    };
    return (Preact.h(Dialog_1.default, { open: p.show }, (Preact.h("form", { onSubmit: function (event) {
            event.preventDefault();
            p.onSubmitClick(newArticleType);
        } },
        Preact.h(Box_1.default, { sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: '16px',
                width: '497px',
                height: '404px',
                padding: '46px',
                boxSizing: 'border-box',
            } },
            Preact.h(Typography_1.default, { variant: "h4" }, !p.failed ? 'Article Type' : 'Adding article failed'),
            Preact.h(TextField_1.default, { id: "article-type", label: "Article Type", variant: "outlined", color: "secondary", size: "small", sx: { marginY: '35px', width: '405px', height: '40px' }, onChange: function (e) { return setNewArticleType(e.target.value); }, value: newArticleType, disabled: p.disabled, error: hasSpaces, autoComplete: "off" }),
            Preact.h(Box_1.default, { sx: {
                    marginBottom: '35px',
                    paddingX: '8px',
                } },
                Preact.h(Typography_1.default, { variant: "body1", fontWeight: 700, textAlign: "center" }, !p.failed
                    ? 'Please input this name correctly as it cannot be changed later'
                    : 'It looks like something has gone wrong. Please try adding the article again.'),
                Preact.h("br", null),
                Preact.h(Typography_1.default, { variant: "body1", textAlign: "center" }, "It must match the attachment point name and it must be in"),
                Preact.h(Typography_1.default, { variant: "body1", fontWeight: 700, textAlign: "center" }, "camelCase"),
                Preact.h("br", null),
                Preact.h(Typography_1.default, { variant: "body1", textAlign: "center" }, "Examples: bathTub, showerTray, basinTap, basin")),
            Preact.h(Box_1.default, { sx: { display: 'flex' } },
                Preact.h(Button.Component, { variant: "outlined", color: "secondary", onClick: onCancelClick, sx: { marginRight: '8px' }, disabled: p.disabled }, "Cancel"),
                Preact.h(Button.Component, { variant: "contained", type: "submit", disabled: p.disabled || hasSpaces }, "Create")))))));
};
exports.Component = Component;
